import { cn } from "@do/ui/lib/utils";

export const ChatContainer = (props: React.ComponentProps<"div">) => {
  return (
    <div
      id="chat"
      role="region"
      className={cn(
        "flex flex-col size-full overflow-hidden",
        "bg-(--background-color)/(--background-color-opacity)"
      )}
      {...props}
    />
  );
};
